import { Injectable } from '@angular/core';
import {  HttpClient, HttpHeaders, HttpErrorResponse, HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable, of ,throwError, } from 'rxjs';
import { map, filter, debounceTime, catchError, tap, delay } from 'rxjs/operators';
import{AppConfigService} from '../app-config.service'
import { AppError } from '../common/class/app-error';
import { IMessageDetails, MessageDetailsResponse,IReceiptFileUploadDetails,ISenderDetails,IReceiptDownloadDetails } from '../class/largereceipt';
import { Router } from '@angular/router';
const config1 = require('../../assets/config.json');


@Injectable({
  providedIn: 'root'
})
export class LargereceiptService {
  baseUrl: string | undefined;

  largeReceiptAPIUrl="api/v1/LargeReceipt/";
  downloadLargeReceiptAPIUrl="api/v1/LargeReceipt/Download/{MessageId}";
  downloadAuthenticatedReceiptAPIUrl="api/v1/LargeReceipt/DownloadAuthenticateReceipt/{Id}";
  tokenAPIUrl="/token?grant_type={GrantType}&username={UserName}&password={Password}";
  //uploadReceiptUrl="http://webapi1.d1.rpost.info/api/v1/Receipt/Verify/Upload";
  uploadReceiptUrl="api/v1/LargeReceipt/upload"
  fileName:any;
  fileUploadDetails: IReceiptFileUploadDetails;
  constructor(private http: HttpClient,private config: AppConfigService,private router:Router) {
    this.baseUrl = this.config.baseApiUrl;
    //alert(config1.APIUrl);
   }
  

   getMessageDetails(messageId:string)
   {
    
    let messageDetailsAPIUrl=this.largeReceiptAPIUrl+"MessageDetails/{MessageId}";
    const url =messageDetailsAPIUrl.replace('{MessageId}', messageId);
    alert(url);
    return this.apiGetById(url);
   }

   getMessageDetailsFromServer(messageId:string):Observable<IMessageDetails> 
   {
    let messageDetails:IMessageDetails;
    let messageDetailsAPIUrl=this.baseUrl+'/'+this.largeReceiptAPIUrl+"MessageDetails/{MessageId}";
    const url =messageDetailsAPIUrl.replace('{MessageId}', messageId);
    
    

    return this.http.get<IMessageDetails>(url)
    .pipe(
      map(result => {
        
        
        return result;
      })
      //,delay(5000)
    ); 

   }

   

   downloadLargeReceipts(messageId:string)
   {
    const url = this.baseUrl+'/'+this.downloadLargeReceiptAPIUrl.replace('{MessageId}', messageId);
    return this.http.get(url, {
      responseType: 'blob'
    });
    
   }

   downloadLargeReceiptsByUrl(messageId:string)
   {
    const url = this.baseUrl+'/'+this.downloadLargeReceiptAPIUrl.replace('{MessageId}', messageId);
    return url;
    
   }


   downloadAuthenticatedReceipt(historyId:string)
   {
    const url = this.baseUrl+'/'+this.downloadAuthenticatedReceiptAPIUrl.replace('{Id}', historyId);
    return this.http.get(url
      , {
      responseType: 'blob'
    }
    );
  
   }

   downloadAuthenticatedReceiptByUrl(historyId:string)
   {
    const url = this.baseUrl+'/'+this.downloadAuthenticatedReceiptAPIUrl.replace('{Id}', historyId);
    return url;
  
   }
    

   getToken(grantType:string,userName:string,password:string)
   {
    const url=this.tokenAPIUrl.replace('{GrantType}', grantType).replace('{UserName}', userName).replace('{Password}',password);
    //return this.http.post(url);
    return this.apiGetById(url);
   }
   
   apiGetById(_url: string) {
     const url = `${this.baseUrl}/${_url}`;
    return this.http.get(url)
    .pipe(
      catchError(this.handleError)  
    );  
   
   }

   uploadReceipt(file:File): Observable<IReceiptFileUploadDetails>
   {
    const formData: FormData = new FormData();

    formData.append('file', file);
    this.fileName=file.name;
    
    let url=this.baseUrl+'/'+this.uploadReceiptUrl;
    
    
    return this.http.post<IReceiptFileUploadDetails>(url, formData);
    
   }

   upload(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);
    this.fileName=file.name;
    const headers1 = new HttpHeaders({
      // 'Content-Type': 'application/json',
      'Access-Control-Allow-Origin':'*',
      'Authorization': 'Bearer z7hQQwwyV9oVmkFUGVMG54jV4VXrmWBoRiDX82oLCDYN5MQvuVcqGlBlzpEejziFt8zgNA3AurBSObrEd-9Y0wtQvpAo1adi2yWEqxPI9hS8kJpNeqiHewYOfuXxKGlQiqXkX2UMalToa3sRzcKb6C0JHPvmyEPsbP30A8nKZ6QdfMf_9khGsIxEEalkq6Cy1Duo1O_rX8l-8FJzd1f4pt7oztu8Qp5S3k6I5_uHEn-PB-it24xVBb9SCC6CH6qcdd5FlO_JvhRwbeUQvntrWKSBVFx3hXdtX2kS0T3yGE4Gv2FhldbUeX7FNgcf6FXPu57F3U-t49Goc_sfgffT602qFY9XJJUbe_IVUfIxGTxgNNRjINZPFrhoHm1YRWtJF6hDdCyOafzEj1eXSTlIXLnfaiRKs5Qfyh4SxdiqiIeAZjECnnuXM8hjVJERnD4007JnMY7tpyoYQ_sMpi8WXgDRxe-PGbYq7bb74M7qjLG-oboaIXZImxU7sepc0JrAUvCHwbeesBQZDZbZuGsS4mLJQXbUETj23vCuTUioPDVeKuBy6SWH1uKuXNTen0TbM6zSS07-rubN7g4k-ylbvQ'
    })

    const req = new HttpRequest('POST', `${this.uploadReceiptUrl}`, formData, {
      reportProgress: true,
      responseType: 'json',
      headers:headers1
    });
    
    
    
    return this.http.request(req);
  }

  getFiles(): string[] {
    
    let files: string[] = [this.fileName];
    return files;
  }
  private handleError(err: HttpErrorResponse ): Observable<AppError> {
    const appError = new AppError(err);
    const errorStatus = err.status;
    const errorStatusText = err.statusText;
    const error: any = err.error;
    let errorMsg = '';
    let msgId = '';
    
    if (error.Message !== undefined && Array.isArray(error.Message)&& err.error.Message[0]!=undefined) {
        errorMsg = err.error.Message[0].Message;
        msgId = err.error.Message[0].MessageId;
    } else {
      if (error.error_description) {
        errorMsg = error.error_description;
      } else {
        if (error.Message) {
          errorMsg = error.Message;
          msgId = (error.MessageId) ? error.MessageId : '';
        } else {
          errorMsg = errorStatusText;
        }
      }
    }

    const retMsg = `Error (${errorStatus}): ${errorMsg}`;
    appError.Message = retMsg;
    appError.MessageId = msgId;

    return of(appError);
  }
   
  deleteFile(fileName:string)
  {
    
    //Call Delete API
    let deleteUploadedFileAPIUrl=this.baseUrl+'/'+this.largeReceiptAPIUrl+"Delete/{filename}/";
    deleteUploadedFileAPIUrl=deleteUploadedFileAPIUrl.replace("{filename}",fileName);
     
      return this.http.delete(deleteUploadedFileAPIUrl)
      .pipe(
        catchError(this.handleError)
      );
    
  }

  authenticateFile(originalFileName:string, fileName:string)
  {
     let authenticateAPIUrl=this.baseUrl+'/'+this.largeReceiptAPIUrl+"Authenticate/";
     
      const data=JSON.stringify({FileName: originalFileName,FileId: fileName,ResponseMessage: ''});
      return this.http.post(authenticateAPIUrl, data , {
        headers: new HttpHeaders({
          'Content-Type':  'application/json'
        })
      })
      .pipe(
        catchError(this.handleError)
      );
      
      
  }

  

   isGuid(stringToTest) {
    if (stringToTest[0] === "{") {
        stringToTest = stringToTest.substring(1, stringToTest.length - 1);
    }
    var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
    return regexGuid.test(stringToTest);
}

  getSenderDetails(messageId:string):Observable<ISenderDetails> 
  {
    
    let senderDetailsAPIUrl=this.baseUrl+'/'+this.largeReceiptAPIUrl+"SenderDetails/{MessageId}";
    const url =senderDetailsAPIUrl.replace('{MessageId}', messageId);
    
    return this.http.get<ISenderDetails>(url)
     .pipe(
      map(result => {
        //alert(result.StatusText);
        if(result.StatusText=="Failure")
        {
          let errorDescription=result.ResultContent.ResponseMessage;
          this.router.navigate(['/ErrorPage',errorDescription]);
        }
        else
          return result;
      })
      //,delay(5000)
    ); 

  }

  /*Begin Download Authenticated Receipt */
  isAuthenticatedReceiptDownloadedOrNot(id:string)
  {
    
    let receiptDetailsAPIUrl=this.baseUrl+'/'+this.largeReceiptAPIUrl+"Authenticated/DownloadedOrNot/{Id}";
    const url =receiptDetailsAPIUrl.replace('{Id}', id);
    
    return this.http.get<IReceiptDownloadDetails>(url)
    .pipe(
      map(result => {
       
        return result;
      })
      
    ); 


  }

  getMessageDetailsByHistoryId(id:string):Observable<IMessageDetails> 
   {
    let messageDetails:IMessageDetails;
    let messageDetailsAPIUrl=this.baseUrl+'/'+this.largeReceiptAPIUrl+"Authenticated/MessageDetails/{Id}";
    const url =messageDetailsAPIUrl.replace('{Id}', id);
    
    return this.http.get<IMessageDetails>(url)
    .pipe(
      map(result => {
        
        
        return result;
      })
      
    ); 

   }  

   getMessageReceiptDetailsByHistoryId(id:string,isDownloaded:boolean,isReceiptExpred:boolean):Observable<IMessageDetails> 
   {
    let messageDetails:IMessageDetails;
    let messageDetailsAPIUrl=this.baseUrl+'/'+this.largeReceiptAPIUrl+"Authenticated/MessageDetails/{Id}";
    const url =messageDetailsAPIUrl.replace('{Id}', id);
    
    return this.http.get<IMessageDetails>(url)
    .pipe(
      map(result => {
        
        result.ResultContent.IsDownloaded=isDownloaded;
        result.ResultContent.IsExpiredReceipt=isReceiptExpred;
        return result;
      })
      
    ); 

   }

  /*End Download Authenticated Receipt */


}


